<template>
  <div>
    <v-toolbar tabs color="white elevation-2" style="top:65px; position:fixed;">
      <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->
      <v-btn icon @click="$router.go(-1)"><v-icon>arrow_back</v-icon></v-btn>
      <v-toolbar-title>{{this.artwork.title}} </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon><v-icon>more_vert</v-icon></v-btn>
      <small>{{this.artwork.artist.name}}</small>

      <v-tabs slot="extension" color="transparent" slider-color="yellow" align-with-title v-model="currentTab">
        <v-tab v-for="tab in this.fields.tabs" :ripple="false"
          :key="tab.key" 
          :href="'#tab-' + tab.key" 
          @click="saveCurrentTab('tab-' + tab.key)"
        >
          {{ tab.title }}
        </v-tab>
      </v-tabs>
    </v-toolbar>

      <v-tabs-items v-model="currentTab" style="top:120px;">
        <v-tab-item v-for="tab in this.fields.tabs" 
          :key="tab.key" 
          :id="'tab-' + tab.key" 
        >
          <v-card flat v-if="!tab.component">
            <v-card-text v-if="tab.fields">
              <field-box v-for="field in tab.fields" :artwork="processedArtwork" :artist="processedArtwork.artist" :field="field" :key="field.key"></field-box>
            </v-card-text>
          </v-card>
          <v-card flat v-else>
            <component v-bind:is="tab.component" :artwork="processedArtwork">
              <!-- component changes when vm.currentView changes! -->
            </component>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
      
  </div>
</template>

<script>
  import FieldBox from './FieldBox'
  import Images from './Images'
  import ExhibitionHistory from './ExhibitionHistory'
  import LoanHistory from './LoanHistory'
  import Tags from './Tags'
  import Packings from './Packings'
  import Todos from './Todos'
  import axios from '@/utils/apiClient'
  import { mapState } from 'vuex'
  import fields from '@/data/full_user_fields'

  export default {
    data () {
      return {
        fields: fields,
        result: '',
        currentTab: this.$store.state.currentTab
        // artwork: '',
        // artist: ''
      }
    },
    props: ['field','artist','artwork'],
    // components: {HeaderArtwork},
    mounted () {
      this.getArtwork()
    },
    // updated () {
    //   this.getArtwork()
    // },
    methods: {
      saveCurrentTab (tab) {
        setTimeout(function () {
          this.$store.dispatch("saveCurrentTab", tab)
        }.bind(this),1000)
      },
      getArtwork () {
        let url = `${this.$globals.apiserver}/artworks/${this.$route.params.id}.json`
        axios.get(url).then((response) => {
          // this.loading = false;
          this.result = response.data
          // this.artwork = response.data
          // this.artist = response.data.artist
          // console.log(this.artist)
          // console.log(this.artwork)
        }).catch((error) => { console.log(error) })
      }
    },
    computed: {
      processedArtwork () {
        // let processedArtwork = this.artwork
        // setTimeout(function () {
        let processedArtwork = this.result
        // }.bind(this),0)
        
        // this.artwork.map(artwork => {
        //   let a = artwork
        //   artwork.first_name = a ? a.first_name : 'nema meno'
        // })
        // console.log(processedArtwork)
        return processedArtwork
      },
      processedArtist () {
        let processedArtist = this.result.artist
        // let artist = this.result.artist
        // this.artist = this.result.artist
        // this.artwork.map(artwork => {
        //   let a = artwork
        //   artwork.first_name = a ? a.first_name : 'nema meno'
        // })
        // console.log(processedArtist)
        return processedArtist
      },
      // value_calculated (field) {
      //   if (field.table == "artists") {
      //     return eval('this.artwork.artist.'+ field.name)
      //   } else {
      //     return eval('this.artwork.'+ field.name)
      //   }
      // }
      // full_user_fields () {
      //   return this.$store.state.full_user_fields
      // }
    },
    components: {FieldBox, Images, ExhibitionHistory, LoanHistory,Packings,Todos,Tags}
  }
</script>

<style scoped>
h1 { font-size: 1em !important; margin-left: 10px; }
small {font-size:1em; float:left; display: block;padding-right: 30px;}
/* .toolbar__title {
    margin-left: 20px!important;
    font-weight: 200;
}
.v-tabs-bar {top: 200px;position: fixed;z-index: 1;} 
.toolbar {margin-top: 0px;top: 80px;position: fixed;z-index: 1;}
div.tabs__bar.theme--dark.grey {margin-top: 0px;top: 200px;position: fixed;z-index: 1;}
.tabs__items {margin-top: 180px;} */
</style>


// WEBPACK FOOTER //
// src/components/artworks/ViewArtwork.vue